export default "__VITE_ASSET__3MHfq8XA__"